import React, { useState } from 'react';

import HeaderNavLinks from 'js/components/header/HeaderNavLinks';
import { staticImageAssets } from 'js/constants/Paths';

import { useData } from 'js/context/DataContext';

// import tracking
import { track, TRACKING_EVENTS } from 'js/utils/tracking';

const HeaderNav = ({ toggleModal }) => {
  const { settings } = useData();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className={`header-nav${isMenuOpen ? ' header-nav--open' : ''}`}>
        <div className="header-nav__bar">
          <div className="header-nav__logo-button header-nav__logo-button--desktop-shadow">
            <img
              className="header-nav__logo"
              src={staticImageAssets('images/static/logo_nav.png')}
              alt="The Bluey Movie"
            />
          </div>
          <button className="header-nav__logo-button" type="button" aria-label="Bluey Movie home">
            <img
              className="header-nav__logo"
              src={staticImageAssets('images/static/logo_nav.png')}
              alt="The Bluey Movie"
            />
          </button>

          <HeaderNavLinks className="header-nav__links--desktop" toggleModal={toggleModal} />

          <button
            className="header-nav__newsletter header-nav__newsletter--desktop"
            type="button"
            aria-label="Newsletter"
          >
            <a href={settings?.subscribe_link?.subscribe_url || ''} target="_blank" rel="noreferrer">
              <img src={staticImageAssets('images/static/btn_mail.png')} alt="" aria-hidden="true" />
            </a>
          </button>

          <button
            className={`header-nav__mobile-watch-button ${isMenuOpen ? 'header-nav__mobile-watch-button--hide' : ''}`}
            type="button"
            aria-label="Watch the teaser"
            onClick={() => {
              toggleModal('video');

              track(TRACKING_EVENTS.CLICK_NAVIGATION_HEADER.id, {
                item_name: 'watch teaser',
                item_link: `watch teaser popup overlay`,
              });
            }}
          >
            Watch the teaser
          </button>

          <button
            className="header-nav__toggle"
            type="button"
            aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
            aria-controls="header-nav-mobile-menu"
            aria-expanded={isMenuOpen}
            onClick={() => setIsMenuOpen((isOpen) => !isOpen)}
          >
            {!isMenuOpen ? (
              <img src={staticImageAssets('images/static/btn_burger_menu.png')} alt="" aria-hidden="true" />
            ) : (
              <img src={staticImageAssets('images/static/btn_burger_menu_close.png')} alt="" aria-hidden="true" />
            )}
          </button>
        </div>
      </header>
      <section
        className={`header-nav__mobile-menu${isMenuOpen ? ' header-nav__mobile-menu--open' : ''}`}
        id="header-nav-mobile-menu"
        aria-label="Main navigation"
      >
        <nav>
          <HeaderNavLinks className="header-nav__links--mobile" onItemClick={closeMenu} toggleModal={toggleModal} />
        </nav>
      </section>
    </>
  );
};

export default HeaderNav;
